const API_URL = (process.env.REACT_APP_API_URL || `${window.location.origin}/api`).replace(/\/$/, '');

const parseResponse = async (response, fallback) => {
  const text = await response.text();
  let data = {};
  try { data = text ? JSON.parse(text) : {}; } catch (_) {}
  if (!response.ok) {
    const error = new Error(data.error || fallback);
    error.status = response.status;
    throw error;
  }
  return data;
};

const request = async (path, options = {}, token = '') => {
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  // Game status and winner data changes daily; never let the browser reuse a
  // stale response after a new result is available.
  const response = await fetch(`${API_URL}${path}`, { cache: 'no-store', ...options, headers });
  return parseResponse(response, 'Hub request failed');
};

const auth = (path, body) => request(path, {
  method: 'POST',
  body: JSON.stringify(body),
});

export const api = {
  games: () => request('/games/'),
  gameContext: (token) => request('/games/context/', {}, token),
  yesterdayWinners: (token) => request('/games/yesterday-winners/', {}, token),
  me: (token) => request('/auth/me/', {}, token),
  login: (identifier, password) => auth('/auth/login/', { identifier, password }),
  signup: (email, displayName, password) => auth('/auth/signup/', { email, display_name: displayName, password }),
  logout: (token) => auth('/auth/logout/', { token }),
  verifyEmail: (token) => auth('/auth/verify-email/', { token }),
  requestPasswordReset: (email) => auth('/auth/request-password-reset/', { email }),
  resetPassword: (token, password) => auth('/auth/reset-password/', { token, password }),
  exchangeLegacy: (token) => auth('/auth/exchange-legacy/', { token }),
};
